/**
 *
 * @module updateUserProfileResult
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    boolean
} = Check.assert;

/**
 *
 * @class UpdateUserProfileResult
 * @since 3.6.0
 *
 */
export default class UpdateUserProfileResult {

    /**
     *
     * @param {Boolean} [refreshAccessToken=false]
     * @throws {InvalidArgumentException}
     *
     */
    constructor(refreshAccessToken = false) {

        const errorMessage = {
            ctor: 'UpdateUserProfileResult(refreshAccessToken)',
            get refreshAccessToken() {
                return `${this.ctor} refreshAccessToken should be a Boolean`;
            }
        };

        if (Check.assigned(refreshAccessToken)) {
            boolean(refreshAccessToken, errorMessage.refreshAccessToken, InvalidArgumentException);
        }

        /**
         *
         * @access public
         * @type {Boolean}
         * @desc Indicates that the access token should be refreshed before proceeding.
         *
         */
        this.refreshAccessToken = refreshAccessToken;

    }

}



// WEBPACK FOOTER //
// ./src/services/account/updateUserProfileResult.js